import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ListArchived } from "@/features/my/list/archived";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  listItemId: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(member)/(protected)/my/list/archived")({
  validateSearch: searchSchema,
  component: ListArchived,
});
